import { render, staticRenderFns } from "./ViAdmin.vue?vue&type=template&id=30aeecc2&scoped=true"
import script from "./ViAdmin.vue?vue&type=script&lang=js"
export * from "./ViAdmin.vue?vue&type=script&lang=js"
import style0 from "./ViAdmin.vue?vue&type=style&index=0&id=30aeecc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30aeecc2",
  null
  
)

export default component.exports